import React from 'react';
import { useStore } from '../../context/StoreContext';

export default function Toast() {
  const { toast } = useStore();
  
  if (!toast.show) return null;
  
  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[200]">
      <div className="px-4 py-3 rounded-2xl bg-slate-900 text-white text-sm font-medium shadow-2xl flex items-center gap-2">
        <i className="ri-check-line text-lg text-emerald-400"></i>
        <span>{toast.message}</span>
      </div>
    </div>
  );
}